// import { GET_TURN_AROUND_TIME } from '@custom/constant';
import { GET_ROLLBACK_ERROR_TRACKING } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getRollbackErrorTracking = createAsyncThunk('getRollbackErrorTracking', async (query: any) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = `${GET_ROLLBACK_ERROR_TRACKING}${query}`;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch analytics details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default getRollbackErrorTracking;
